<script>
    const urlParams = new URLSearchParams(window.location.search);
    const visitedFromTTI = urlParams.has('tti');

</script>
<h1 class="title">
    Documentation
</h1>

<div class="columns is-multiline">
    <div class="column is-one-third is-full-touch">
        <div class="card">
            <header class="card-header">
                <p class="card-header-title">
                Tellsens API
                </p>
                <button class="card-header-icon" aria-label="more options">
                <span class="icon has-text-grey-light">
                    <i class="fas fa-book" aria-hidden="true"></i>
                </span>
                </button>
            </header>
            <div class="card-content">
                <div class="content">
                    <p>
                        Tellsens offers REST API's to our customers. The following endpoints are available at request:
                    </p>
                    <pre>GET base-url/devices/&#123;app-id&#125</pre>
                    <p>Fetches all device connected to a given app.</p>
                    <pre>GET base-url/gps-positions/&#123;device-eui&#125;</pre>
                    <p>Fetches gps history for a given device.</p>
                    <p><strong>Please contact our support team at support@tellsens.no for activation.</strong></p>
                </div>
            </div>
            <footer class="card-footer">
                <!-- svelte-ignore a11y-missing-attribute -->
                <div class="card-footer-item is-narrow is-size-7"> </div>
                <!-- svelte-ignore a11y-missing-attribute -->
                <div class="card-footer-item is-narrow is-size-7"></div>
                <a class="card-footer-item is-narrow is-size-7" href="mailto:support@tellsens.no">Contact us</a>
            </footer>
        </div>
    </div>
    {#if visitedFromTTI}
        <div class="column is-one-third is-full-touch">
            <div class="card">
                <header class="card-header">
                    <p class="card-header-title">
                    The Things Industries
                    </p>
                    <button class="card-header-icon" aria-label="more options" type="button" disabled>
                    <span class="icon has-text-grey-light">
                        <i class="fas fas fa-book" aria-hidden="true"></i>
                    </span>
                    </button>
                </header>
                <div class="card-content">
                    <div class="content">
                    <ol>
                        <li>Create your account at Tellsens.</li>
                        <li>Follow the instructions provided by your cloud provider.</li>
                        <li>IOT data will be populated and presented the app you connected with your cloud provider.</li>
                    </ol>
                    </div>
                </div>
                <footer class="card-footer">
                    <!-- svelte-ignore a11y-missing-attribute -->
                    <div class="card-footer-item is-narrow is-size-7"> </div>
                    <!-- svelte-ignore a11y-missing-attribute -->
                    <div class="card-footer-item is-narrow is-size-7"> </div>
                    <a class="card-footer-item is-narrow is-size-7" href="https://www.thethingsindustries.com/docs/integrations/cloud-integrations/tellsens/" target="_blank">Visit partner</a>
                </footer>
            </div>
        </div>
    {/if}
</div> 

<style>
    .card-content {
        min-height: 80px;
    }
    .card-header-icon {
        cursor: default;
    }

</style>

